import { PodcastCardMain } from "./PodcastCardMain";

export default PodcastCardMain;
